import React, { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from 'gatsby-plugin-react-i18next';

const ContactForm = ({ messageHeight = '10rem', serviceName }) => {
    const {t} = useTranslation();

    const [isSending, setIsSending] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const formProps = Object.fromEntries(formData);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formProps)
        }

        setIsSending(true);
        fetch("https://us-central1-gambit-lab.cloudfunctions.net/sendEmail", requestOptions)
            .then(res => {
                window.showToast("successToast");
                setIsSending(false);
            })            
            .catch(error => {
                window.showToast("errorToast");
                setIsSending(false);
            });
    };

    return(        
        <form onSubmit={onSubmit}>
            <input id="service" name="service" type="hidden" value={serviceName} />

            <div className="form-floating mb-3">
                <input className="form-control" id="fullName" name="fullName" type="text" />
                <label htmlFor="name">{t("contact-form-name")}</label>
            </div>

            <div className="form-floating mb-3">
                <input className="form-control" id="email" required type="email" name="email" />
                <label htmlFor="email">{t("contact-form-email")}</label>
            </div>

            <div className="form-floating mb-3">
                <input className="form-control" id="web" type="url" name="web" />
                <label htmlFor="web">{t("contact-form-web")}</label>
            </div>

            <div className="form-floating mb-3">
                <textarea className="form-control" id="message" name="message" type="text" style={{"height": messageHeight}}></textarea>
                <label htmlFor="message">{t("contact-form-message")}</label>
            </div>

            <div className="d-grid">
                <button className="btn btn-dark btn-lg text-white" id="submitButton" type="submit" disabled={isSending}>{t("contact-form-send")} {isSending && <span className="spinner-border spinner-border-sm" role="status"></span>}
                </button>
            </div>
        </form>
    );
};

export default ContactForm;